import { styled, createGlobalStyle } from "styled-components";
import { devices } from "../../utils/styled/_variables.styled";
import { ModalMiaStyle } from "./ModalMia.types";

export const ModalMiaContainer = styled.div``;
export const GlobalModalMiaStyle = createGlobalStyle<ModalMiaStyle>`
  #modalMia {
    .default {
      width: 100%;
      height: unset;
      min-height: 48px;
      @media ${devices.desktop} {
        margin-top: 0 !important;
        max-width: 360px;
      }
    }
    
    .modal__title{
      color: ${(props) => props.$modalTitleColor};
    }

    background: ${(props) => props.$backgroundColor} !important;
    gap: 0px !important;
    text-align: start;
    
    #form-simulation{
        padding-top: 0px !important;
    }

    > div:nth-of-type(2) {
      margin: 120px 0 40px 0;
      padding: 0;

      h2 {
        display: none;
      }

      .subtitle-form {
        text-align: start;
      }
    }
  }
`;
